import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../../apiClient';
import { FileWithUrl } from '../../documents';

export interface FormResponseDocument {
    _id: string;
    responseId: string;
    documentId: string;
    createdAt: string;
    updatedAt: string;
    file?: FileWithUrl;
}

export interface FormResponseDocumentsResponse {
    message: string;
    data: FormResponseDocument[];
}

export interface FormResponseDocumentResponse {
    message: string;
    data: FormResponseDocument;
}

export const getDocumentsByResponseId = async (responseId: string): Promise<FormResponseDocumentsResponse> => {
    try {
        const response: AxiosResponse<FormResponseDocumentsResponse> = await apiClient.get(`/form-response-documents/${responseId}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};
